import { fetchChannelDataRows } from "../../utilities/apiRequests";
/**
 * Fetches all city coordinates from the CityCoordinates.json file.
 * @returns {Promise<Array>} A promise that resolves to an array of city coordinates.
 */
export async function fetchCityCoordinates() {
    try {
        const response = await fetch("/data/CityCoordinates.json");
        if (!response.ok) {
            throw new Error(`Failed to fetch city coordinates: ${response.statusText}`);
        }
        const cityCoordinates = await response.json();
        return cityCoordinates;
    } catch (error) {
        console.error("Error fetching city coordinates:", error);
        return [];
    }
}

/**
 * Fetches all channel data from the API.
 * @param {Function} getAccessTokenSilently - Auth0 function to retrieve the access token.
 * @returns {Promise<Array>} A promise that resolves to an array of channel data.
 */
export async function fetchAllChannelData(getAccessTokenSilently) {
    try {
        const accessToken = await getAccessTokenSilently({ authorizationParams: { scope: "read:channels" } });
        const fields = ["call_sign", "market", "affiliation", "channel_id", "atsc1_vp1_deployed", "website_vod_assets"]; //later add "devices", "avg_viewer" and more
        const channelData = await fetchChannelDataRows(accessToken, fields);
        return channelData;
    } catch (error) {
        console.error("Error fetching channel data:", error);
        return [];
    
    }
}